export interface DueDiligence {
    id?: string;
    personEntity?: string;
    residency?: string;
    relationshipDesignation?: string;
    complianceDocuments?: string;
    name?: string;
    complianceName?: string;
    individualName?: string;
    institutionName?: string;
    dateCreated?: Date;
    dateModified?: Date;
    createdBy?: string;
    modifiedBy?: string;
}

export class DueDiligencePanelController {
    public isOpen: boolean = false;
    public isEdit: boolean = false;
    public dueDiligence: DueDiligence = {};
    public errorMessage: string = '';
    public onSave: (dueDiligence: DueDiligence) => void;
    public onClose: () => void;
    public onDelete: (dueDiligence: DueDiligence) => void;
    
    // Relationship designation options
    public relationshipDesignationOptions: string[] = [
        'Spouse',
        'Self',
        'Father',
        'Mother',
        'Child',
        'Immediate Shareholder',
        'Ultimate Beneficial Owner',
        'Trust',
        'Foundation',
        'Societe',
        'Succession',
        'Pension Scheme',
        'Individual Related Party',
        'Corporate Related Party',
        'Corporate Signatory',
        'Authorised Signatory',
        'Director',
        'Corporate Director',
        'Shareholder',
        'Nominee',
        'Settlor',
        'Trustee',
        'Promotor',
        'Administrator'
    ];

    // Residency options
    public residencyOptions: string[] = [
        'Resident',
        'Non-Resident'
    ];

    /** @ngInject */
    constructor() {}

    public $onInit(): void {
        this.resetForm();
    }

    public open(dueDiligence?: DueDiligence): void {
        this.isOpen = true;
        this.isEdit = !!dueDiligence;
        this.errorMessage = ''; // Clear any previous errors
        
        // Prevent body scroll
        document.body.classList.add('slide-out-panel-open');
        
        if (dueDiligence && typeof dueDiligence === 'object') {
            this.dueDiligence = { ...dueDiligence };
        } else {
            this.resetForm();
        }
    }

    public close(): void {
        this.isOpen = false;
        this.errorMessage = ''; // Clear errors when closing
        
        // Restore body scroll
        document.body.classList.remove('slide-out-panel-open');
        
        if (this.onClose) {
            this.onClose();
        }
    }

    public save(): void {        
        // Clear previous error messages
        this.errorMessage = '';
        
        // Validate required fields
        if (!this.dueDiligence || !this.dueDiligence.personEntity) {
            this.errorMessage = 'Person / Entity is required. Please provide this information before saving.';
            console.error('Person / Entity is required');
            return; // Don't save or close the panel
        }

        // Ensure dueDiligence is properly initialized
        if (!this.dueDiligence) {
            this.dueDiligence = {};
        }

        // Add timestamps
        if (!this.dueDiligence.dateCreated) {
            this.dueDiligence.dateCreated = new Date();
        }
        this.dueDiligence.dateModified = new Date();

        if (this.onSave) {
            (this.onSave as any)({ dueDiligence: this.dueDiligence });
        }
        
        this.close();
    }



    public delete(): void {
        if (this.dueDiligence && this.dueDiligence.id) {
            if (this.onDelete) {
                (this.onDelete as any)({ dueDiligence: this.dueDiligence });
            }
        }
        this.close();
    }

    private resetForm(): void {
        this.dueDiligence = {
            id: undefined,
            personEntity: '',
            residency: '',
            relationshipDesignation: '',
            complianceDocuments: '',
            name: '',
            complianceName: '',
            individualName: '',
            institutionName: '',
            dateCreated: null,
            dateModified: null,
            createdBy: '',
            modifiedBy: ''
        };
    }
}

export const DueDiligencePanelComponent: angular.IComponentOptions = {
    template: require('./due-diligence-panel.html'),
    controller: DueDiligencePanelController,
    controllerAs: '$ctrl',
    bindings: {
        onSave: '&',
        onClose: '&',
        onDelete: '&'
    }
};



// WEBPACK FOOTER //
// ./src/app/clients/clients.details/compliance/modals/tabs/due-diligence/due-diligence-panel.ts